import { IN_BROWSER } from '@components/utils';

let supportsPassive = false;
try {
  if (IN_BROWSER) {
    const opts = Object.defineProperty({}, 'passive', {
      get() {
        supportsPassive = true;
      }
    });

    window.addEventListener('testPassive', null as any, opts);
    window.removeEventListener('testPassive', null as any, opts);
  }
} catch (e) {
  console.error(e);
}

function addEventListenerWrapper<K extends keyof WindowEventMap>(
  target: Element | Window | Document | null,
  eventType: K,
  listener: (event: Event | any) => void,
  option?: boolean | AddEventListenerOptions | undefined
) {
  if (target && target.addEventListener) {
    let opt = option;
    if (
      opt === undefined &&
      supportsPassive &&
      (eventType === 'touchstart' || eventType === 'touchmove' || eventType === 'wheel')
    ) {
      opt = { passive: false };
    }
    target.addEventListener(eventType, listener, opt);
  }
  return {
    remove: () => {
      if (target && target.removeEventListener) {
        target.removeEventListener(eventType, listener);
      }
    }
  };
}

export { addEventListenerWrapper, supportsPassive };
